import React, { useEffect, useState } from 'react';
import NapAreaTypeRepository from '../../repository/NapAreaTypeRepository';
import { strings } from '../../Localization/Localization';
import Select from 'react-select';
import UserRepository from '../../repository/UserRepository';

const NapAreaEdit = (props) => {

  const [listNapAreas, setListNapAreas] = useState([]);
  const [users, setUsers] = useState([]);

  const getNapAreas = () => {
    NapAreaTypeRepository.findAllActiveAreaTypes().then(res => {

      res.data.map(item => {
        listNapAreas.push({
          value: item.id,
          label: localStorage.getItem('activeLanguage') === 'mk' ? item.nameMk : item.nameAl,
          name: 'napAreaTypeId'
        });
      });
    });
  };

  const getSupervisors = () => {
    UserRepository.findAllSupervisors().then(res => {
      const supervisors = res.data?.map(s =>
        ({
          value: s.id,
          label: s.firstName + ' ' + s.lastName + ' (' + s.email + ')',
          name: 'supervisorId'
        }));
      setUsers(supervisors);
    });
  };

  useEffect(() => {
    getNapAreas();
    getSupervisors();
  }, []);

  const onChangeHandler = (e) => {
    props.onChange(e.target.name, e.target.value);
  };

  const onSelectedAreaTypeChangeHandler = (areaType) => {
    if (areaType !== null) {
      props.onChange(areaType.name, areaType.value);
    } else {
      props.onChange('napAreaTypeId', null);
    }
  };

  const onSelectedSupervisorChangeHandler = (supervisors) => {
    const ids = supervisors?.map(s => s.value)
    props.onChange('supervisorIds', ids);
  };

  return (

    <div className='col-12'>
      <div className='row'>
        <div className='col-12 mt-2'>
          <label
            className='weight400 text-upper control-label control-label-xl margin-top-10'>{strings.nameMk}</label>
          <input
            defaultValue={props.entity.nameMk ? props.entity.nameMk : ''}
            name={'nameMk'}
            type={'text'}
            placeholder={''}
            className='form-control'
            onChange={(e) => onChangeHandler(e)}
          />
          <p>Ве молиме пред името внесете го&nbsp;
            <span style={{ textDecoration: 'underline' }}>бројот на типот на областа на НС</span> и&nbsp;
            <span style={{ textDecoration: 'underline' }}>следниот број на областа</span>.
            Пример: <span style={{ textDecoration: 'underline' }}>5.10</span> каде што 5 е бројот на типот на областа, а
            10 следниот број на областа.
          </p>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 mt-3'>
          <label
            className='weight400 text-upper control-label control-label-xl margin-top-10'>{strings.nameAl}</label>
          <input
            defaultValue={props.entity.nameAl ? props.entity.nameAl : ''}
            name={'nameAl'}
            type={'text'}
            placeholder={''}
            className='form-control'
            onChange={(e) => onChangeHandler(e)}
          />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 mt-3'>
          <label
            className='weight400 text-upper control-label control-label-xl margin-top-10'><small
            style={{ color: 'red' }}>*</small>{strings.supervisor}</label>

          <Select
            placeholder={''}
            className='basic-single'
            classNamePrefix='select'
            isDisabled={false}
            isLoading={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            options={users}
            isMulti
            onChange={onSelectedSupervisorChangeHandler}
            name={'supervisorId'}
            defaultValue={props?.entity?.supervisorOptions}
          />

        </div>
      </div>

      <div className='row'>
        <div className='col-12 mt-3'>
          <label
            className='weight400 text-upper control-label control-label-xl margin-top-10'>{strings.code}</label>
          <input
            defaultValue={props.entity.code ? props.entity.code : ''}
            name={'code'}
            type={'text'}
            placeholder={''}
            className='form-control'
            onChange={(e) => onChangeHandler(e)}
          />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 mt-3'>
          <label
            className='weight400 text-upper control-label control-label-xl margin-top-10'><small
            style={{ color: 'red' }}>*</small>{strings.areaTypes}</label>

          <Select
            placeholder={''}
            className='basic-single'
            classNamePrefix='select'
            isDisabled={false}
            isLoading={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            options={listNapAreas}
            onChange={onSelectedAreaTypeChangeHandler}
            name={'napAreaTypeId'}
            defaultValue={props.entity.napAreaType !== null && props.entity.napAreaType !== undefined ? {
              value: props.entity.napAreaType.id,
              label: props.entity.napAreaType.nameMk,
              name: 'napAreaTypeId'
            } : ''}
          />

        </div>
      </div>

      <div className='row'>
        <div className='col-12 mt-3'>
          <label
            className='weight400 text-upper control-label control-label-xl margin-top-10'>{strings.descMk}</label>
          <textarea
            defaultValue={props.entity.descriptionMk ? props.entity.descriptionMk : ''}
            name={'descriptionMk'}
            rows={3}
            placeholder={''}
            className='form-control'
            onChange={(e) => onChangeHandler(e)}
          />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 mt-3'>
          <label
            className='weight400 text-upper control-label control-label-xl margin-top-10'>{strings.descAl}</label>
          <textarea
            defaultValue={props.entity.descriptionAl ? props.entity.descriptionAl : ''}
            name={'descriptionAl'}
            rows={3}
            placeholder={''}
            className='form-control'
            onChange={(e) => onChangeHandler(e)}
          />
        </div>
      </div>

    </div>
  );
};

export default NapAreaEdit;
